import React  from 'react';
import './input.css';

const Input = ({classList, title, type, value, onChange, name}) => {
  return (
      <label
          className={`input ${
              classList !== undefined ? classList : ''
          }`}
      >
        <span className="input__title">{title}</span>
        <div className="input__inner">
          <input
              type={type}
              className="input__field"
              value={value || ''}
              onChange={onChange}
              name={name}
          />
        </div>
      </label>
  );
}

export default Input;
